module.exports = __webpack_public_path__ + "assets/views/intro/information_button_bg.png";